<form #schedulelesson="ngForm" (ngSubmit)="scheduleLiveLesson()" class="mt-4 mb-0">
  <div class="fieldset fieldset--lg">
    <label class="legend" for="scheduledatetime">Lesson Date/Time <span class="requiredfield">*</span></label>
    <input [owlDateTime]="rawscheduledatetime" class="text-field" id="scheduledatetime" name="scheduledatetime" #scheduledatetime required [(ngModel)]="this.schedule.utcScheduledDateTime">
    <button [owlDateTimeTrigger]="rawscheduledatetime" type="button" class="owlDateTimeTrigger position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center px-3 bg-transparent border-0 text-body" autofocus title="Calendar">
      <i class="fa fa-calendar"></i>
    </button>
    <owl-date-time #rawscheduledatetime></owl-date-time>
    <button type="button" data-toggle="dropdown" aria-expanded="false" title="Lesson date and time"
      class="position-absolute right-4 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
        class="fa fa-info-circle"></i></button>
    <div class="info-popup dropdown-menu p-2">
      <p class="form-info-p">When the session starts, in your own time zone. It cannot be in the past.</p>
    </div>
  </div>
  <div class="fieldset fieldset--lg">
    <label class="legend" for="livelessonmode">Mode <span class="requiredfield">*</span></label>
    <select class="text-field" id="livelessonmode" name="livelessonmode" [(ngModel)]="schedule.mode" #schedulemode="ngModel" required>
      <option value="{{this.focusmode}}">Lecture Mode (Up to 2,500 Students)</option>
      <option value="{{this.meetingmode}}">Meeting Mode (Up to 200 Students)</option>
    </select>
  </div>
  <div class="fieldset fieldset--lg flex-row align-items-center">
    <label class="mb-0 text-sm" for="allowstudentsdownloadrecording">Allow Students Download Recording <span class="requiredfield"></span></label>
    <input type="checkbox" class="ml-2" id="allowstudentsdownloadrecording" name="allowstudentsdownloadrecording" [(ngModel)]="schedule.allowStudentsDownloadRecording" #allowstudentsdownloadrecording="ngModel" />
  </div>
  <div class="fieldset fieldset--lg flex-row align-items-center">
    <label class="mb-0 text-sm" for="sendemailnotification">Send Email Notification <span class="requiredfield"></span></label>
    <input type="checkbox" class="ml-2" id="sendemailnotification" name="sendemailnotification" [(ngModel)]="schedule.sendemailnotification" #sendemailnotification="ngModel" />
    <button type="button" data-toggle="dropdown" aria-expanded="false" title="Send email notification"
      class="position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
        class="fa fa-info-circle"></i></button>
    <div class="info-popup dropdown-menu p-2">
      <p class="form-info-p">Emails every student on the course, showing the date and time in their own time zone. Leave it off if you are only correcting a detail.</p>
    </div>
  </div>
  <div class="d-flex justify-content-center flex-wrap gap-1.5">
    <button [disabled]="loading || (!schedulelesson.valid && (this.scheduleid == 0 || !this.scheduleid))" class="btn m-0" type="submit">Save</button>
    <button [disabled]="loading" class="btn btn--warning m-0" type="button" routerLink="/user/lesson" [queryParams]="{ classid: classid }">Cancel</button>
  </div>
</form>
